export enum TripSummaryTab {
  Passengers = 'Passengers',
  Itinerary = 'Itinerary',
  TicketPrices = 'TicketPrices',
  TicketConditions = 'TicketConditions',
}
